<script>
import { formatSeconds } from '@dygc/shared'
import { createPopup } from '@/assets/js/factory'
import bus from '@/views/cati/bus'
import CallResult from '@/views/cati/c/CallResult.vue'
import { updateNumberRemark } from '@/api/cati'
import { CallLocalStatus, CallStatus } from '@/views/cati/enum'
import { formatPhoneNumber } from '@/views/cati/util'

export default {
  name: 'CallBox',
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selectCallId: {
      type: null,
      default: ''
    },
    prediction:{
      type:Boolean,
      default: false
    }
  },
  data() {
    return {
      status: 0,
      editRemark: false,
      time: 0
    }
  },
  computed: {
    isDisabled() {
      if (!bus.currentCall) return false
      if (this.isSameCallInfo()) return false
      return [CallLocalStatus.Calling, CallLocalStatus.Connected].includes(bus.catchStatus)
    },
    formatTime() {
      return bus.formatTime
    },
    isTerminateAnswer() {
      // 是否是终止答题
      const codes = [CallStatus.NotMyself, CallStatus.Noise, CallStatus.Refusal,CallStatus.Robot,CallStatus.Noise,CallStatus.RoleError,CallStatus.Other,CallStatus.Busy]
      return codes.includes(this.data.status)
    },
    canCall() {
      const codes = [CallStatus.Completed, CallStatus.NotMyself, CallStatus.Noise, CallStatus.Refusal]
      return !codes.includes(this.data.status)
    },
    statusClass() {
      const res = []
      switch (this.status) {
        case 0:
          res.push('waiting')
          break
        case 1:
          res.push('calling')
          break
        case 2:
          if (this.selectCallId === this.data.id) {
            res.push('select')
            break
          } else {
            res.push('waiting')
          }
      }
      if (this.isDisabled) {
        res.push('disabled-call')
      }
      return res.join(' ')
    }
  },
  watch: {
    selectCallId() {
      if (this.selectCallId === this.data.id) {
        this.status = 2
      } else {
        this.status = 0
      }
    }
  },
  methods: {
    formatPhoneNumber,
    onAnswer(){
      bus.$emit('answer',this.data)
    },
    onCalling() {
      if (this.prediction) return
      // if (this.data.status === 2) return
      bus.call(this.data)
    },
    onCallRelease() {
      this.status = 0
      if (!this.isSameCallInfo()) return
      this.status = 2
    },
    onCallEstablish() {
      this.status = 0
      if (!this.isSameCallInfo()) return
      this.status = 1
    },
    onHangUp(type) {
      this.status = 0
      if (!this.isSameCallInfo()) return
      this.status = 2
    },
    onSelect() {
      if (this.isDisabled) return
      if (this.status === 0 || this.status === 2) {
        this.status = 2
        this.$emit('update:select-call-id', this.data.id)
      }
    },
    onBlurRemark() {
      this.editRemark = false
      updateNumberRemark(this.data.id, this.data.numberRemark)
    },
    onEditRemark() {
      this.editRemark = true
    },
    isSameCallInfo() {
      return this.data.id === bus.currentCall?.id
    }
  },
  created() {
    if (this.selectCallId === this.data.id) {
      this.status = 2
    }
  },
  mounted() {
    bus.$on('onCallRelease', this.onCallRelease)
    bus.$on('onCallEstablish', this.onCallEstablish)
    bus.$on('onHangUp', this.onHangUp)
    if (this.isSameCallInfo()) {
      if (bus.catchStatus === CallLocalStatus.Connected) {
        this.status = 1
      }
    }
  },
  beforeDestroy() {
    bus.$off('onCallRelease', this.onCallRelease)
    bus.$off('onCallEstablish', this.onCallEstablish)
    bus.$off('onHangUp', this.onHangUp)
  }
}
</script>

<template>
  <div class="call-box" :class="statusClass" @click="onSelect">
    <div>
      <template v-if="data.sampleName && data.sampleName !=='-'">
        <span>{{ data.sampleName }}</span>
        <span>-</span>
      </template>
      <span>{{ formatPhoneNumber(data.phoneNumber) }}</span>
    </div>
    <div class="mt-1 flex items-center">
      <template v-if="editRemark">
        <el-input autofocus class="flex-1" placeholder="标签" v-model="data.numberRemark" @blur="onBlurRemark" />
      </template>
      <template v-else>
        <template v-if="data.numberRemark">
          <span>{{ data.numberRemark }}</span>
        </template>
        <template v-else>
          <span>标签</span>
        </template>
      </template>
      <span class="ml-1 cursor-pointer hover:text-theme" @click="onEditRemark">
        <i class="icon-bianji"></i>
      </span>
    </div>
    <div class="mt-2" v-if="canCall">
      <div v-if="!prediction" class="status-btn" @click="onCalling">
        <span v-if="status!==1">拨打</span>
        <span v-else>通话中{{ formatTime }}</span>
        <span class="text-large" v-if="status===1">
          <i class="icon-call"></i>
        </span>
      </div>
      <div v-else class="status-btn">
        <span v-if="status!==1"></span>
        <span v-else>通话中{{ formatTime }}</span>
      </div>
    </div>
    <div class="mt-2" v-if="isTerminateAnswer">
      <span>终止答题: {{ data.remark }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.call-box {
  font-size: 14px;
  padding: 12px;

  border-radius: 2px;
  line-height: 22px;

  .status-btn {
    padding: 5px 12px;
    border-radius: 16px;
    line-height: 22px;
    text-align: center;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover {
      @apply bg-theme-100;
    }

  }

  &.select {
    background: #F0F8FF;

    .status-btn {
      cursor: pointer;
      @apply border border-solid border-theme text-theme;
      transition: all .3s;

      &:hover {
        @apply text-white bg-theme;
      }
    }
  }

  &.calling {
    background-color: #F3FFEB;

    .status-btn {
      background: #72C74E;
      color: #fff;
      display: flex;
      justify-content: space-between;
    }
  }

  &.waiting {
    background: #FAFAFA;

    .status-btn {
      background: #F5F5F5;

      &:hover {
        @apply bg-theme-100;
      }
    }
  }

  &.disabled-call {
    position: relative;

    &:after {
      content: " ";
      z-index: 10;
      position: absolute;
      @apply inset-0;
      cursor: not-allowed;
    }
  }
}
</style>
